<template>
<div class="mb-4">
  <h4>Search</h4>
  <input class="shadow appearance-none border rounded w-full py-2 px-3 text-grey-darker leading-tight focus:outline-none focus:shadow-outline" id="search_name" type="text" placeholder="Search" v-model="searchval">
  <button class="bg-blue hover:bg-blue-dark text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" type="button" @click.prevent="updateSearch">
    Search
  </button>
  <div class="search_tags">
    <li v-for="cursearch in cursearches" v-bind:key="cursearch">
      {{ cursearch }}
      <a href="#" :data-search="cursearch" v-on:click="removeSearch($event)">🗑️</a>
    </li>
  </div>
</div>
</template>

<script>
export default {
  name: 'Search',
  data () {
    return {
      searchval: ''
    }
  },
  mounted () {
    this.search = this.$store.getters.search
  },
  methods: {
    updateSearch () {
      this.$store.commit('ADD_SEARCH', this.searchval)
    },
    removeSearch (event, val) {
      if (event) event.preventDefault()
      var searchTag = event.currentTarget.getAttribute('data-search')
      this.$store.commit('REMOVE_SEARCH', searchTag)
    }
  },
  computed: {
    cursearches () {
      return this.$store.getters.search
    }
  }
}
</script>

<style>
#app {
}
</style>



// WEBPACK FOOTER //
// src/components/search.vue